module.exports = __webpack_public_path__ + "static/img/9.304fb2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/9.png
// module id = H97Z
// module chunks = 0